import React, {useState} from 'react';
import Draggable from 'react-draggable';
import SMCModalHeader from './SMCModalHeader';
import PropTypes from 'prop-types';
import {Modal} from '@mui/material';
import { makeStyles } from '@mui/styles';
import {useModalDimensions} from '../../../utils/hooks';
import LoadingContainer from '../../Page/LoadingContainer';

function SMCModal({
    isOpen,
    title,
    height,
    width,
    onRequestClose,
    loading,
    hasError,
    errorMessage,
    reloadData,
    children
}) {
    const classes = useStyles();

    // Modal height and width are dynamically calculated so that the modal is not larger then the window
    const { modalHeight, modalWidth } = useModalDimensions({ maxHeight: height, maxWidth: width });
    // randomHandleId is necessary so that each header will have a unique id and can be dragged individually (Draggable receives an id as a handle selector)
    const [randomHandleId,] = useState(String(Math.floor(Math.random()*100000)));

    return (
        <Modal
            open={isOpen}
            className={classes.modal}
            disableBackdropClick
            disableEscapeKeyDown
            onClose={onRequestClose}
        >
            {/* This Fragment is necessary to avoid an error in console whenever Modal opens*/}
            <>
            <Draggable handle={'[id*="'+randomHandleId+'"'} bounds="body">
                <div className={classes.root} style={{ height: modalHeight, width: modalWidth }}>
                    <SMCModalHeader
                        title={title}
                        closeFunction={onRequestClose}
                        innerId={randomHandleId}
                    />
                    {/* window content */}
                    <div className={classes.innerPage}>
                        {
                            (hasError || errorMessage) ? (
                                <div className="center" style={{ textAlign: 'center', lineHeight: '32px' }}>
                                    Error loading data...<br />
                                    {
                                        errorMessage && (
                                            <div>{errorMessage}</div>
                                        )
                                    }
                                    {
                                        reloadData ? (
                                            <button onClick={reloadData}>Try again</button>
                                        ) : (
                                            <span>
                                                Please try again
                                            </span>
                                        )
                                    }
                                </div>
                            ) : (
                                <LoadingContainer loading={loading}>
                                    {children}
                                </LoadingContainer>
                            )
                        }
                    </div>
                </div>
            </Draggable>
            </>
        </Modal>
    );
}

SMCModal.propTypes = {
    isOpen: PropTypes.bool,
    title: PropTypes.string.isRequired,
    height: PropTypes.number,
    width: PropTypes.number,
    onRequestClose: PropTypes.func.isRequired,
    children: PropTypes.node.isRequired
}

const useStyles = makeStyles({
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },
    root: {
        background: 'white',
        pointerEvents: 'all',
        boxShadow: '0 0 0 1px rgba(0, 0, 0, 0.05), 0 2px 4px rgba(0, 0, 0, 0.2)',
        overflow: 'hidden',
        outline: 'none'
    },
    innerPage: {
        padding: '10px',
        background: '#F7F7F7',
        height: '100%',
        width: '100%'     
    }
});

export default SMCModal;